export const quotes = [
  {
    text: "천리길도 한 걸음부터",
    author: "한국 속담"
  },
  {
    text: "시작이 반이다",
    author: "한국 속담"
  },
  {
    text: "꿈을 계속 간직하고 있으면 반드시 실현할 때가 온다.",
    author: "�괴테"
  },
  {
    text: "실패는 성공의 어머니다",
    author: "한국 속담"
  },
  {
    text: "하늘은 스스로 돕는 자를 돕는다.",
    author: "서양 격언"
  },
  {
    text: "지나간 일로 후회하지 말고, 오지 않은 일로 걱정하지 마라.",
    author: "조선 격언"
  },
  {
    text: "산 넘어 산",
    author: "한국 속담"
  },
  {
    text: "세상에서 가장 쉬운 일은 포기하는 것이고, 가장 어려운 일은 견디는 것이다.",
    author: "베냐민 프랭클린"
  },
  {
    text: "백지장도 맞들면 낫다",
    author: "한국 속담"
  },
  {
    text: "누워서 떡 먹기",
    author: "한국 속담"
  },
  {
    text: "오늘 할 수 있는 일을 내일로 미루지 마라.",
    author: "베냐민 프랭클린"
  },
  {
    text: "가는 말이 고와야 오는 말이 곱다",
    author: "한국 속담"
  },
  {
    text: "호랑이도 제 말 하면 온다",
    author: "한국 속담"
  },
  {
    text: "노력하는 자는 희망을 말하고, 게으른 자는 불만을 말한다.",
    author: "알랭"
  },
  {
    text: "웃는 얼굴에 침 뱉으랴",
    author: "한국 속담"
  },
  {
    text: "교육은 세상을 바꿀 수 있는 가장 강력한 무기이다.",
    author: "넬슨 만델라"
  },
  {
    text: "돌다리도 두들겨 보고 건너라",
    author: "한국 속담"
  },
  {
    text: "작은 일에 최선을 다하는 사람만이 큰 일에서도 최선을 다할 수 있다.",
    author: "아인슈타인"
  },
  {
    text: "낮말은 새가 듣고 밤말은 쥐가 듣는다",
    author: "한국 속담"
  },
  {
    text: "급할수록 돌아가라",
    author: "한국 속담"
  }
]